import { useLocation } from "react-router-dom";

import type { MaxwellSubject } from "@/types/maxwell";

export interface MaxwellSubjectWithKey extends MaxwellSubject {
  /** Stable key for the action bus: `<type>:<id>` (`global:` for global). */
  key: string;
}

/**
 * Derive Maxwell's current subject from the route. The panel is mounted in the
 * app shell (above the routed `Outlet`), so we parse the id out of the
 * pathname rather than `useParams`, which would be empty up here.
 */
export function useMaxwellSubject(): MaxwellSubjectWithKey {
  const { pathname } = useLocation();

  const deal = pathname.match(/^\/deals\/([^/]+)/);
  if (deal) {
    return { type: "deal", id: deal[1], key: `deal:${deal[1]}` };
  }
  const customer = pathname.match(/^\/customers\/([^/]+)/);
  if (customer) {
    return { type: "customer", id: customer[1], key: `customer:${customer[1]}` };
  }
  return { type: "global", id: null, key: "global:" };
}
